import React from "react";
import { twMerge } from "tailwind-merge";
import AppLoader from "./AppLoader";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    loading?: boolean;
    variant?: "contained" | "outlined";
};

function AppButton({
    loading,
    className,
    children,
    variant = "contained",
    ...props
}: Props) {
    return (
        <button
            disabled={props.disabled || loading}
            className={twMerge(
                variant === "contained" && "btn-primary",
                variant === "outlined" && "btn-outline-primary",
                loading && 'pointer-events-none',
                className
            )}
            {...props}
        >
            {loading ? <AppLoader size="sm" /> : children}
        </button>
    );
}

export default AppButton;
